import { useMemo } from "react";

type Props = {
	canceled?: boolean;
	totalGuestCharge: number;
};

export const TotalGuestChargeOfPrintComposition = ({ canceled, totalGuestCharge }: Props) => {
	/**
	 * タイトル
	 */
	const titlePrefixText = useMemo(() => (canceled ? "キャンセル" : "お支払い"), [canceled]);
	/**
	 * お客様の合計料金をローカライズ
	 */
	const totalGuestChargeText = useMemo(() => `¥ ${totalGuestCharge.toLocaleString()}`, [totalGuestCharge]);

	return (
		<div className="flex w-full items-center justify-end gap-x-10">
			<p className="text-sm font-bold">{titlePrefixText}料金</p>

			<p className="text-sm underline">{totalGuestChargeText}</p>
		</div>
	);
};
